export const setCurrentWidgetFilterValuesReducer = (state, action) => {
    if (!action.payload.widget) {
        return;
    }
    if (!state.currentWidgetFilterValues) {
        state.currentWidgetFilterValues = {};
    }
    if (!state.currentWidgetFilterValues[action.payload.widget] || action.payload.filters.length === 0) {
        state.currentWidgetFilterValues[action.payload.widget] = {};
    }
    for (const payload of action.payload.filters) {
        const { filter, values } = payload;
        if (state.currentWidgetFilterValues && state.currentWidgetFilterValues[action.payload.widget] && values.length !== 0) {
            state.currentWidgetFilterValues[action.payload.widget][filter] = values;
        }
        else {
            delete state.currentWidgetFilterValues[action.payload.widget][filter];
        }
    }
};
